import inicialState from './fish.state';
import * as actions from './fish.action';

const fishReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.FISH_FINALIZADA:
      return {
        ...state,
        fishFinalizada: action.payload.fishFinalizada,
      };
    default:
      return state;
  }
};

export default fishReducer;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/fish/fish.reducer.js